import Simple from "./img/simple.png";
import Dom from "./img/dom1.png";
import Currency from "./img/currency.png";
import LinkedLin from "./img/linkedlin-clone.png";
import Template from "./img/template.png";
import Todo from "./img/todo-react.png";
import Gmail from "./img/gmail-clone.png";
import Shop from "./img/shop.png";
import Netflix from "./img/netflix.png";
import Spotify from "./img/sportify.png";
import Construction from "./img/construction.png";
import Deliveroo from "./img/Deliveroo-clone.png";
import Instagram from "./img/instagram.png";
import FoodBag from "./img/FoodBag.PNG";
import Design from "./img/Onboarding.png";
import Quiz from "./img/Quiz.png";
import Hospital from "./img/hospital.png";
import TaxDoc from "./img/javadoctax.png";
import HealthDoc from "./img/javadochealth.png";
import Dufuna from "./img/dufuna.png";
import Blog from "./img/blog.png";
import Bode from "./img/bode.png";
import Ecwa from "./img/ecwa-mega.png";
import Fetch from "./img/fetch.png";
import Kwikee from "./img/kwikee.png";
import MoneyMarque from "./img/moneymarque.png";
import Rebble from "./img/rebble.png";
import Bpayex from "./img/bpayex.png";
import Celler from "./img/celler.png";
import Slide1 from "./slideName/slide_1.jpg";
import Slide2 from "./slideName/slide_2.jpg";
import Slide3 from "./slideName/slide_3.jpg";
import Slide4 from "./slideName/slide_4.jpg";
import Slide5 from "./slideName/slide_5.jpg";
import Slide6 from "./slideName/slide_6.jpg";
import Slide7 from "./slideName/slide_7.jpg";
import Slide8 from "./slideName/slide_8.jpg";

export const portfolio = [
  {
    id: 1254561,
    title: "Rebble App",
    image: Rebble,
    link: "https://www.rebble.app",
    githublink: "#",
  },
  {
    id: 1254561,
    title: "Kwikee App",
    image: Kwikee,
    link: "https://kwikee.app",
    githublink: "#",
  },
  {
    id: 1254561,
    title: "MoneyMarque",
    image: MoneyMarque,
    link: "https://www.moneymarqueng.com",
    githublink: "#",
  },
  {
    id: 1254561,
    title: "Bpayex App",
    image: Bpayex,
    link: "https://bpayex.com",
    githublink: "#",
  },
  {
    id: 1254561,
    title: "Celler App",
    image: Celler,
    link: "https://www.celler.app",
    githublink: "#",
  },
  {
    id: 1254561,
    title: "DUFUNA",
    image: Dufuna,
    link: "https://learning.dufuna.com",
    githublink: "#",
  },
  {
    id: 1234466,
    title: "ECWA Mega Gbagada",
    image: Ecwa,
    link: "https://ecwamegagbagada.com.ng",
    githublink: "",
  },
  {
    id: 1254,
    title: "BODE ADEDIJI PARTNERSHIP",
    image: Bode,
    link: "new.bodeadedijipartnership.com",
    githublink: "#",
  },
  {
    id: 2,
    title: "ROCK CRYSTAL AND LAY CONSTRUCTION LIMITED",
    image: Construction,
    link: "https://construction-sigma.vercel.app/",
    githublink: "https://github.com/Samju200/construction",
  },
  {
    id: 1256,
    title: "HOSPITAL MANAGEMENT APP",
    image: Hospital,
    link: "https://hospital-taupe.vercel.app",
    githublink: "https://github.com/Samju200/hospital",
  },
  {
    id: 125456,
    title: "JAVADOC FOR E-HEALTH APP",
    image: HealthDoc,
    link: "https://samju200.github.io/javadochealth/",
    githublink: "https://github.com/Samju200/e-healthcare",
  },
  {
    id: 125,
    title: "JAVADOC FOR TAX CAlCULATION",
    image: TaxDoc,
    link: "https://samju200.github.io/javadoc-tax",
    githublink: "https://github.com/Samju200/taxCalculator",
  },
  {
    id: 12674,
    title: "Blog App",
    image: Blog,
    link: "https://blog-plathform-client.vercel.app/",
    githublink: "https://github.com/Samju200/blog-plathform-client",
  },
  {
    id: 12344,
    title: "ECWA LWDYC Bible Quiz App",
    image: Quiz,
    link: "http://16.171.7.108/",
    githublink: "",
  },
  {
    id: 12346,
    title: "FETCH DASHBOARD",
    image: Fetch,
    link: "https://samju200.github.io/dashboard/",
    githublink: "",
  },

  {
    id: 123,
    title: "FoodBag",
    image: FoodBag,
    link: "https://foodbag-three.vercel.app/",
    githublink: "https://github.com/Samju200/foodbag",
  },
  {
    id: 6,
    title: "Spotify Clone",
    image: Spotify,
    link: "https://sportify-lake.vercel.app/",
    githublink: "https://github.com/Samju200/sportify",
  },

  {
    id: 1,
    title: "Netflix Clone",
    image: Netflix,
    link: "https://netflix-clone-37df8.web.app/",
    githublink: "https://github.com/Samju200/netflix-clone",
  },
  {
    id: 4,
    title: "Instagram Clone",
    image: Instagram,
    link: "https://instagram-next-kappa.vercel.app/",
    githublink: "https://github.com/Samju200/instagram-next",
  },
  {
    id: 7,
    title: "Gmail Clone",
    image: Gmail,
    link: "https://clone-6faf4.web.app/",
    githublink: "https://github.com/Samju200/gmail-clone",
  },
  {
    id: 9,
    title: "LinkedlIn Clone",
    image: LinkedLin,
    link: "https://linkedin-clone-yt-4878b.web.app/",
    githublink: "https://github.com/Samju200",
  },
  {
    id: 3,
    title: "Template",
    image: Template,
    link: "https://samju200.github.io/formplus-template-task/",
    githublink: "https://github.com/Samju200/formplus-template-task",
  },

  {
    id: 5,
    title: "Shop With Samju",
    image: Shop,
    link: "https://samju200.github.io/my-online-shop",
    githublink: "https://github.com/Samju200/my-online-shop",
  },
  {
    id: 1234,
    title: "Deliveroo React_native App",
    image: Deliveroo,
    link: "",
    githublink: "https://github.com/Samju200/deliveroo-clone",
  },

  {
    id: 8,
    title: "Currency Exchange",
    image: Currency,
    link: "https://samju200.github.io/samju/currency/index.html",
    githublink: "https://github.com/Samju200/samju/tree/master/currency",
  },

  {
    id: 10,
    title: "Product Design",
    image: Design,
    link: "https://www.behance.net/gallery/116553949/African-food-restaurant",
    githublink:
      "https://www.figma.com/file/ocdynE5cpgsMdSnwAVUbIY/Team-2--AFI-(Copy)?node-id=556%3A19801",
  },

  {
    id: 12,
    title: "Advance Todo Dragging and drop",
    image: Todo,
    link: "https://samju200.github.io/todo/",
    githublink: "https://github.com/Samju200/todo",
  },

  {
    id: 13,
    title: "E-Commerce",
    image: Simple,
    link: "https://samju200.github.io/samju/simple/product.html",
    githublink: "https://github.com/Samju200/samju/tree/master/simple",
  },

  {
    id: 14,
    title: "Dom",
    image: Dom,
    link: "https://samju200.github.io/DOM/dom1/dom.html",
    githublink: "https://github.com/Samju200/DOM/tree/master/dom1",
  },
];
export const slideImage = [
  {
    id: 1,
    image: Slide1,
  },
  {
    id: 2,
    image: Slide2,
  },
  {
    id: 3,
    image: Slide3,
  },
  {
    id: 4,
    image: Slide4,
  },
  {
    id: 5,
    image: Slide5,
  },
  {
    id: 6,
    image: Slide6,
  },
  {
    id: 7,
    image: Slide7,
  },
  {
    id: 8,
    image: Slide8,
  },
];
